import { HSLColor } from '@yola/yola-palette-generator';
import { rules, utils } from '@yola/ws-color-rules';
import initAssignVariable from './init-assign-variable';
import generatePalette from './generate-palette';
import {
  LIGHT_COLOR_TYPE,
  DARK_COLOR_TYPE,
  PRIMARY_COLOR_TYPE,
  SECONDARY_COLOR_TYPE,
  ERROR_COLOR_TYPE,
  WARNING_COLOR_TYPE,
  SUCCESS_COLOR_TYPE,
  INFO_COLOR_TYPE,
} from '../constants/common';

const { increaseColorPointByStep, reduceColorPointByStep } = utils;

const buildTemplateContext = ({ config, colors }) => {
  const {
    light,
    altLight,
    dark,
    altDark,
    primary,
    secondary,
    error = new HSLColor(351, 1, 0.96),
    warning = new HSLColor(46, 1, 0.94),
    success = new HSLColor(127, 0.47, 0.93),
    info = new HSLColor(199, 0.94, 0.94),
    whiteColor = new HSLColor(0, 0, 1),
    blackColor = new HSLColor(0, 0, 0),
  } = colors;

  const palettes = {
    lightPalette: generatePalette(light, LIGHT_COLOR_TYPE),
    altLightPalette: generatePalette(altLight, LIGHT_COLOR_TYPE),
    darkPalette: generatePalette(dark, DARK_COLOR_TYPE),
    altDarkPalette: generatePalette(altDark, DARK_COLOR_TYPE),
    primaryPalette: generatePalette(primary, PRIMARY_COLOR_TYPE),
    secondaryPalette: generatePalette(secondary, SECONDARY_COLOR_TYPE),
    errorPalette: generatePalette(error, ERROR_COLOR_TYPE),
    warningPalette: generatePalette(warning, WARNING_COLOR_TYPE),
    successPalette: generatePalette(success, SUCCESS_COLOR_TYPE),
    infoPalette: generatePalette(info, INFO_COLOR_TYPE),
  };

  const context = {
    colors: {
      light,
      altLight,
      dark,
      altDark,
      primary,
      secondary,
      error,
      warning,
      success,
      info,
      whiteColor,
      blackColor,
    },
    palettes,
    rules,
    increaseColorPointByStep,
    reduceColorPointByStep,
    assignVariable: initAssignVariable({
      cssVariablesMap: config.css_variables_map,
      palettes,
      whiteColor,
      blackColor,
    }),
  };

  return context;
};

export default buildTemplateContext;
